'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function readJsonLines(string) {
  return string.split('\n').filter(line => line).map(line => line.trim()).map(line => JSON.parse(line));
}

exports.default = readJsonLines;